import { CollectionCardProps } from 'app/components/collection/CollectionCard'
import {
  CollectionType,
  createCollectionFragment,
} from 'app/queries/collections/collection-fragment'
import { Pagination } from 'app/types/pagination'
import { gql } from 'graphql-request'

import { defaultsQuery } from '../globals/defaults'

export type CollectionListQueryOptions = {
  excludeHidden?: boolean
  sort?: string
}

export const mapToCollectionCard = (
  type: CollectionType,
  data: any,
  defaults: any
): CollectionCardProps => {
  return {
    id: data.id,
    image:
      data.thumbnail?.sizes?.square?.url ||
      defaults.thumbnail.sizes.thumbnail.url,
    title: data.name,
    href: `/${type.toLowerCase()}/${data.slug}`,
    itemCount: data.itemCount || 0,
  }
}

export const createCollectionListQuery = (
  type: CollectionType = 'Collection',
  options?: CollectionListQueryOptions
) => {
  const { excludeHidden = false } = options || {}
  const collectionListQuery = gql`
    ${createCollectionFragment(type)}
    query getAllCollection($limit: Int!, $page: Int!, $sort: String) {
      ${type}s (sort: $sort, limit: $limit, page: $page
      ${excludeHidden ? ', where: {isHidden: {equals: false}}' : ''}) {
        totalDocs
        page
        docs {
          ...collection
        }
      }
      ${defaultsQuery}
    }
  `

  const collectionListSlugQuery = gql`
    query getAllCollection($limit: Int!, $page: Int!, $order: String) {
      ${type}s (sort: $order, limit: $limit, page: $page
      ${excludeHidden ? ', where: {isHidden: {equals: false}}' : ''}) {
        totalDocs
        page
        docs {
          slug
        }
      }
    }
  `

  const queryToList = (data: any): Pagination<CollectionCardProps> => {
    const res = data[type + 's']

    const docs = res.docs.map((item: any) =>
      mapToCollectionCard(type, item, data.Defaults)
    )

    return {
      total: res.totalDocs,
      page: res.page,
      docs,
    }
  }

  const slugQueryToList = (data: any): Pagination<{ slug: string }> => {
    const res = data[type + 's']

    return {
      total: res.totalDocs,
      page: res.page,
      docs: res.docs.map((item: any) => ({ slug: item.slug })),
    }
  }

  return {
    query: collectionListQuery,
    mapToCollectionList: queryToList,
    slugQuery: collectionListSlugQuery,
    mapToCollectionSlugList: slugQueryToList,
  }
}
